module.exports = __webpack_public_path__ + "img/hutaomu4.6fd753b0.jpg";